import { Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";

import { IntegrationScreenContext } from "../context/IntegrationScreenContext.ts";
import { IntegrationScreenHelper } from "../context/IntegrationScreenHelper.ts";
import { IntegrationBreadcrumbs } from "./IntegrationBreadcrumbs.tsx";
import { XeroAccountMappingCard } from "./XeroAccountMappingCard.tsx";
import { XeroCard } from "./XeroCard.tsx";
import { XeroConfigurationCard } from "./XeroConfigurationCard.tsx";

const XeroPage: React.FC = () => {
  const root = useStores();
  return (
    <IntegrationScreenContext.Provider
      value={new IntegrationScreenHelper(root)}
    >
      <IntegrationBreadcrumbs />
      <Stack tokens={{ childrenGap: 24 }}>
        <XeroCard />
        <XeroConfigurationCard />
        <XeroAccountMappingCard />
      </Stack>
    </IntegrationScreenContext.Provider>
  );
};

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default XeroPage;
